
















import { Component } from 'vue-property-decorator';
import Emoticons from '../../ScoreInput/Emoticons.vue';
import ClassEES from './ClassEES';

@Component({ components: { Emoticons } })
export default class ClassEES7Emoji extends ClassEES {}
